export const AUTH_USER = "auth_user";
export const AUTH_ADMIN = "auth_admin";
export const UNAUTH_USER = "unauth_user";
export const AUTH_ERROR = "auth_error";
export const CLEAR_ERROR = "clear_error";
export const GOOGLE_AUTH_DATA = "google_auth_user";
export const GOOGLE_AUTH_DATA_CLEAR = "google_auth_user_clear";
